import script from "./FilterChild.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterChild.vue?vue&type=script&setup=true&lang=js"

import "./FilterChild.vue?vue&type=style&index=0&id=5271aae4&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5271aae4"]])

export default __exports__